// Objects
export const renameKey = (o, oldKey, newKey) => {
  delete Object.assign(o, { [newKey]: o[oldKey] })[oldKey];
};

export const mapValues = (o, formatter) => {
  return Object.fromEntries(
    Object.entries(o).map(([k, v]) => [k, formatter(v, k)]) // make key available as optional second arg
  );
};

// Dates
export const isValidDate = maybeDate =>
  maybeDate && // check if 'falsy'
  Object.prototype.toString.call(maybeDate) === '[object Date]' && // does it have the correct instance type?
  !Number.isNaN(maybeDate); // check if 'Invalid Date'

export const makeDateTime = (date, time) => {
  try {
    // normalize to Date object
    let dateAsDate = date instanceof Date ? date : new Date(date);
    if (!isValidDate(dateAsDate)) {
      throw `Invalid date provided! ${date}`;
    }
    let [dateString, timeString] = dateAsDate.toLocalISOString().split('T');
    timeString = time + timeString.slice(time.length, timeString.length);
    return `${dateString}T${timeString}`;
  } catch (error) {
    console.error(error);
  }
};

// Numbers
export const formatNumber = (
  // REFACTOR: only supports currency, not any other potential NumberFormat params.
  // Consider scope to currency only and registering in i18n/NumberFormats, and/or defining Intl.NumberFormat per use case.
  number,
  style,
  locale = 'nl-NL',
  currency = 'EUR'
) => {
  return new Intl.NumberFormat(locale, {
    style,
    currency,
  }).format(number);
};

export const formatCurrency = (
  number,
  options = {}
) => {
  var allOptions = {
    ...options,
    locale: 'nl-NL',
    currency: 'EUR',
    style: 'currency',
  };
  allOptions.currency = allOptions.currency.toUpperCase();

  return new Intl.NumberFormat(allOptions.locale, allOptions).format(number);
};

export const formatBits = (bits, decimals = 2) => {
  if (bits == 0) return ['0', 'KB'];

  var k = 1024,
    dm = decimals,
    sizes = ['b', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bits) / Math.log(k));

  return `${parseFloat((bits / Math.pow(k, i)).toFixed(dm)).toLocaleString()} ${sizes[i]}`;
};

// Theme
export const getColorArrayModNumber = (colorArray = [], number) => {
  return colorArray.length > 0
    ? colorArray[Number.parseInt(number) % colorArray.length]
    : '#FFF';
};